import React from 'react';

import Devices from './devices';
import TenantsDetails from './tenants-details';
import { styles } from './widgets/baseWidget';
import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';
import Loader from '../common/loader';

const rowBaseStyles = {
  container: {
    flexWrap: 'wrap',
    maxWidth: '85vw'
  }
};

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      totalDevices: 0,
      unMappedDevices: 0,
      totalTenants: 0,
      suspendedTenants: 0,
      tenantList: [],
      tenantDeviceCountMap: {},
      refreshDeviceLength: 10000
    };

    this._getAllDataBind = this._getAllData.bind(this);
  }

  componentDidMount() {
    this._getAllData();
    this._isMounted = true;
  }

  componentWillUnmount(){
    this._triggerRefreshTimer(false);
    this._isMounted = false;
  }

  _showError(err, msg='') {
    const { body = {} } = err.res || {};
    const errormsg = body.error ? body.error.charAt(0).toUpperCase() + body.error.slice(1) 
      : 'Please check our connection';
    AppActions.setSnackbar(preformatWithRequestID(err.res, `${msg} ${errormsg}`));    
  }

  _triggerRefreshTimer(trigger) {
    if (trigger && !this.timerId && this._isMounted) {
      this.timerId = setTimeout(this._getAllDataBind, this.state.refreshDeviceLength);
    } else if(!trigger && this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  _getAllData() {
    this._triggerRefreshTimer(false);
    Promise.all([AppActions.getAllTenantDeviceMap(), AppActions.getAllTenants()])
      .then(results => {
        const deviceMap = Array.isArray(results[0]) ? results[0] : [];
        let unMappedDevices = 0;
        const tenantDeviceCountMap = {};
        deviceMap.forEach((item) => {
          if (item.Tenant) {
            if (!tenantDeviceCountMap[item.Tenant]) {
              tenantDeviceCountMap[item.Tenant] = 1;
            } else {
              tenantDeviceCountMap[item.Tenant] += 1;
            }
          } else {
            unMappedDevices += 1;
          }
        });

        const tenantList = Array.isArray(results[1]) ? results[1] : [];
        const suspendedTenants = tenantList.reduce((acc, item) => item.status === 'Active' ? acc : acc + 1, 0);
        this.setState({ loading: false, totalDevices: deviceMap.length, unMappedDevices, 
          totalTenants: tenantList.length, suspendedTenants, tenantList, tenantDeviceCountMap });
      })
      .catch(err => {
        this.setState({ loading: false });
        this._showError(err);
      })
      .finally(() => {
        this._triggerRefreshTimer(true);
      })
  }

  _handleClick(params) {
    if (params.route) {
      this.props.history.push(params.route);
    }
  }

  render() {
    const rowStyles = Object.assign({}, rowBaseStyles.container, styles.rowStyle);
    let content = (<Loader show={true} />);

    if (!this.state.loading) {
      content = (
        <>
          <Devices styles={rowStyles} clickHandle={this._handleClick.bind(this)} 
            totalDevices={this.state.totalDevices}
            unMappedDevices={this.state.unMappedDevices}
          />
          <TenantsDetails styles={rowStyles} clickHandle={this._handleClick.bind(this)}
            tenantList={this.state.tenantList}
            tenantDeviceCountMap={this.state.tenantDeviceCountMap}
            totalTenants={this.state.totalTenants}
            suspendedTenants={this.state.suspendedTenants}
          />
        </>
      );
    }

    return (
      <div>
        <div className="dashboard">
          {content}
        </div>
      </div>
    );
  }
}
